import React, { FC } from 'react';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { MainContent } from 'src/pages-all/master-page/components/main-content';
import styled from 'styled-components';
import { headlineFontSize, knownFromList } from 'src/pages-all/home/home.page.const';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Typography } from 'antd';
import { colors } from 'styles/colors';

const SectionContainer = styled.div<any>`
  padding: 8px 0 32px 0;
  display: flex;
  justify-content: center;
  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(252, 254, 253, 1) 100%);
`;

const ImageWrapper = styled.div<any>`
  display: flex;
  justify-content: center;
  row-gap: 20px;
  column-gap: 40px;
  flex-wrap: wrap;
`;

const KnownFromHeadline = styled.div`
  margin: 22px auto;
`;

export const KnownFrom: FC = () => {
  const { minDesktop, min500, maxMobileLarge } = useBreakpoints();
  const { Title } = Typography;

  return (
    <SectionContainer minDesktop={minDesktop} min500={min500}>
      <MainContent
        style={{
          maxWidth: '1470px',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          padding: '0px 30px',
        }}
      >
        <KnownFromHeadline>
          <Title
            level={2}
            style={{
              fontSize: headlineFontSize(maxMobileLarge),
              color: colors.blueGray,
              fontWeight: 700,
            }}
          >
            {translate(translationKeys.homepage.knownFrom.headline)}
          </Title>
        </KnownFromHeadline>
        <ImageWrapper>
          {knownFromList.map((img, i) => (
            <img key={i} src={img.src} alt={img.alt} height={maxMobileLarge ? 40 : 60} />
          ))}
        </ImageWrapper>
      </MainContent>
    </SectionContainer>
  );
};
